module.exports = __webpack_public_path__ + "static/assets/dab2db227832b34cdeb61b1f3d83110f.svg";